import React, { type ReactNode } from "react";
import { Box, Typography, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CollapsibleSectionProps {
  title: string;
  count?: number;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  icon?: ReactNode;
}

export function CollapsibleSection({
  title,
  count,
  expanded,
  onToggle,
  children,
  icon,
}: CollapsibleSectionProps) {
  return (
    <>
      <Box
        onClick={onToggle}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          py: 1,
          px: 2,
          mx: 0.75,
          borderRadius: 1,
          transition: "background-color 0.15s ease",
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <ExpandMoreIcon
          sx={{
            fontSize: "1.25rem",
            color: "text.secondary",
            transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.2s ease",
          }}
        />
        {icon}
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
          {count != null && ` (${count})`}
        </Typography>
      </Box>
      <Collapse in={expanded}>{children}</Collapse>
    </>
  );
}
